/* ============================================================================
   password-policy.js - shared signup / change-password rules
   ============================================================================ */

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_HINT =
  "8+ characters, one capital letter, one number or symbol (@ # $ …)";

const HAS_UPPER = /[A-Z]/;
const HAS_DIGIT_OR_SYMBOL = /[\d@#$!%&*?_\-+=[\]{}|;:'",.<>/?\\`~^()]/;

export function validatePassword(password) {
  const value = String(password || "");

  if (value.length < PASSWORD_MIN_LENGTH) {
    return { ok: false, message: `Password must be at least ${PASSWORD_MIN_LENGTH} characters.` };
  }
  if (!HAS_UPPER.test(value)) {
    return { ok: false, message: "Include at least one capital letter." };
  }
  if (!HAS_DIGIT_OR_SYMBOL.test(value)) {
    return { ok: false, message: "Include at least one number or symbol (e.g. @ # $)." };
  }

  return { ok: true };
}
